// utils/logoutHandler.js

let globalNavigate = null;

/**
 * Registers navigate() so it can be used globally
 */
export const registerNavigate = (navigateFn) => {
  globalNavigate = navigateFn;
};

/**
 * Call this to navigate to the logout screen from anywhere
 */
export const logoutHandler = (reason = { isTimeOut: false }) => {
  if (globalNavigate) {
    globalNavigate("/logout", { replace: true, state: reason });
  } else {
    console.error("logoutHandler: navigate not registered yet");
  }
};

export const loginNavigate = () => {
  if (globalNavigate) {
    globalNavigate("/", { replace: true });
  } else {
    console.error("loginHandler: navigate not registered yet");
  }
};


export const serviceMaintanceHandler = (state = {}) => {
  if (globalNavigate) {
    globalNavigate('/tenant/users/service-maintenance', { replace: true, state });
  } else {
    console.error("serviceMaintanceHandler: navigate not registered yet");
  }
};
